module.exports = __webpack_public_path__ + "static/media/next-exercise.c58fbd4e.png";